export default __webpack_public_path__ + "static/lutein-zeaforce-slider-lifestyle-tablet-c0f7784382a5d316e7f429fa60a8f4bc.jpg";